import angular from 'angular';

import TreeModel from './tree';
import IssuesGrouping from '../../groupings/issues';

function IssuesTreeFactory(TreeModel, IssuesGrouping) {
  return class IssueTreeModel extends TreeModel {
    constructor() {
      super();
      this.grouping = IssuesGrouping;
      this.setApi("/case/:caseId/values/legalIssues", {
        caseId: '@caseId'
      }, { // actions
        'get': {
          method: 'GET',
          isArray: true
        },
        'update': {
          method: 'PUT',
          isArray: true,
        }
      });
    }
  }
}

IssuesTreeFactory.$inject = ['TreeModel', 'IssuesGrouping'];

export default angular.module('models.issue-tree', [TreeModel, IssuesGrouping])
  .factory('IssuesTreeFactory', IssuesTreeFactory)
  .service('IssuesTree', ['IssuesTreeFactory', IssuesTreeFactory => new IssuesTreeFactory()])
  .name;



// WEBPACK FOOTER //
// ./project/models/trees/issues.js